import React from "react";
import { Table, Badge, Button } from "reactstrap";
import { formatModerationMessage } from "utils/formatMessage";

const UserReportsTable = ({ data, onReview }) => {

    return (
        <Table className="align-items-center moderation-table" responsive>
            <thead className="thead-light">
                <tr>
                    <th>Message</th>
                    <th>User</th>
                    <th>Reporter</th>
                    <th>Category</th>
                    <th>Timestamp</th>
                    <th>Status</th>
                    <th className="text-right">Actions</th>
                </tr>
            </thead>
            <tbody>
                {data.map((item, index) => {
                    const cleanMessage = formatModerationMessage(item.message);
                    return (
                    <tr key={item.id || index}>
                        <td style={{ maxWidth: "300px", whiteSpace: "normal" }}>
                            <span
                                className="text-sm font-weight-600 mb-0"
                                style={{ cursor: "pointer", transition: "color 0.2s" }}
                                onClick={() => onReview(item)}
                                onMouseEnter={(e) => e.target.style.color = "#5e72e4"}
                                onMouseLeave={(e) => e.target.style.color = ""}
                            >
                                {item.isE2EE && <i className="ni ni-lock-circle-open text-muted mr-1" title="End-to-End Encrypted (Decrypted for Moderation)" />}
                                {cleanMessage?.length > 80 ? cleanMessage.substring(0, 80) + "..." : cleanMessage}
                            </span>
                        </td>
                        <td>
                            <div className="d-flex align-items-center">
                                <div>
                                    <span className="text-sm font-weight-bold d-block">{item.user}</span>
                                    <small className="text-muted">{item.handlerName} | {item.userEmail}</small>
                                </div>
                            </div>
                        </td>
                        <td>
                            <span className="text-sm">{item.reporter}</span>
                        </td>
                        <td>
                            <Badge color="secondary" className="status-badge-pill text-dark">
                                {item.category}
                            </Badge>
                        </td>
                        <td>
                            <span className="text-xs text-muted">
                                {new Date(item.timestamp).toLocaleString()}
                            </span>
                        </td>
                        <td>
                            <div className="d-flex flex-column align-items-start">
                                {(() => {
                                    const actions = item.actionHistory || [];
                                    const latestAction = actions.length > 0 ? actions[actions.length - 1] : (item.status || 'pending');

                                    return (
                                        <Badge color={latestAction === 'pending' ? 'danger' : 'success'} className="status-badge-pill mb-1" style={{ textTransform: 'uppercase' }}>
                                            {latestAction}
                                        </Badge>
                                    );
                                })()}
                            </div>
                        </td>
                        <td className="text-right">
                            <div className="d-flex justify-content-end align-items-center">
                                <Button
                                    color="primary"
                                    size="sm"
                                    outline
                                    onClick={() => onReview(item)}
                                >
                                    Details
                                </Button>
                            </div>
                        </td>
                    </tr>
                );
                })}
            </tbody>
        </Table>
    );
};

export default UserReportsTable;
